import * as form from '../form';

export const relationshipsPeople = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Address: form.location(xitem.Address),
        Name: form.name(xitem.Name),
        Name2013: form.text(xitem.Name2013),
        Dates: form.daterange(xitem.Dates),
        Email: form.email(xitem.Email),
        ContactFrequency: form.radio(xitem.ContactFrequency),
        ContactFrequencyOther: form.text(xitem.ContactFrequencyOther),
        EmailNotApplicable: form.notapplicable(xitem.EmailNotApplicable),
        Emails: form.collection(form.emailCollection(xitem.Emails)),
        MobileTelephone: form.telephone(xitem.MobileTelephone),
        OtherTelephone: form.telephone(xitem.OtherTelephone),
        Rank: form.text(xitem.Rank),
        RankNotApplicable: form.notapplicable(xitem.RankNotApplicable),
        Relationship: form.checkboxgroup(xitem.Relationship),
        RelationshipOther: form.text(xitem.RelationshipOther),
        Comments: form.textarea(xitem.Comments),
        CurrentRelationship: form.radio(xitem.CurrentRelationship),
        CurrentRelationshipOtherExplanation: form.textarea(xitem.CurrentRelationshipOtherExplanation),
      },
    };
  });
  return {
    List: form.collection(items, (data?.List || {}).branch),
    Comments: form.textarea(data?.Comments),
  };
};
